import { useWebsocketUpdates } from "@finbackoffice/site-core";
import { HoursRange, IClientError, IEventFeedResponse } from "@finbackoffice/websocket-client";
import { useState, useMemo, useCallback } from "react";

interface IEventsState {
    data: IEventFeedResponse[];
    loading: boolean;
}

export const usePrematchUpcomingEvents = (
    hoursRange: HoursRange,
    enableFallback: boolean = false,
) => {
    const [events, setEvents] = useState<IEventsState>({
        data: [],
        loading: true,
    });
    const [isFallback, setIsFallback] = useState(false);

    const onSocketUpdate = useCallback(
        (events: IEventFeedResponse[], error: IClientError) => {
            if (!error) {
                if (events.length) {
                    setEvents({
                        data: events,
                        loading: false,
                    });
                } else if (enableFallback && !isFallback) {
                    setIsFallback(true);
                } else {
                    setEvents((state) => ({
                        ...state,
                        loading: false,
                    }));
                }
            } else {
                setEvents((state) => ({
                    ...state,
                    loading: false,
                }));
            }
        },
        [enableFallback, isFallback],
    );

    const payload = useMemo(
        () => ({ hours: !isFallback ? hoursRange : HoursRange.ALL }),
        [hoursRange, isFallback],
    );

    useWebsocketUpdates("upcoming", onSocketUpdate, undefined, payload);

    return { events, setEvents };
};
